/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Status_Token_LimitInputs */

const en_admin_ai_chat_status_token_limit = /** @type {(inputs: Admin_Ai_Chat_Status_Token_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly token limit reached`)
};

const de_admin_ai_chat_status_token_limit = /** @type {(inputs: Admin_Ai_Chat_Status_Token_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatliches Token-Limit erreicht`)
};

const es_admin_ai_chat_status_token_limit = /** @type {(inputs: Admin_Ai_Chat_Status_Token_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límite mensual de tokens alcanzado`)
};

const fr_admin_ai_chat_status_token_limit = /** @type {(inputs: Admin_Ai_Chat_Status_Token_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limite mensuelle de tokens atteinte`)
};

const nl_admin_ai_chat_status_token_limit = /** @type {(inputs: Admin_Ai_Chat_Status_Token_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maandelijks tokenlimiet bereikt`)
};

/** @type {(inputs: Admin_Ai_Chat_Status_Token_LimitInputs) => LocalizedString} */
const it_admin_ai_chat_status_token_limit = en_admin_ai_chat_status_token_limit;

/** @type {(inputs: Admin_Ai_Chat_Status_Token_LimitInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_status_token_limit = en_admin_ai_chat_status_token_limit;

/** @type {(inputs: Admin_Ai_Chat_Status_Token_LimitInputs) => LocalizedString} */
const pl_admin_ai_chat_status_token_limit = en_admin_ai_chat_status_token_limit;

/** @type {(inputs: Admin_Ai_Chat_Status_Token_LimitInputs) => LocalizedString} */
const hu_admin_ai_chat_status_token_limit = en_admin_ai_chat_status_token_limit;

/** @type {(inputs: Admin_Ai_Chat_Status_Token_LimitInputs) => LocalizedString} */
const ro_admin_ai_chat_status_token_limit = en_admin_ai_chat_status_token_limit;

/**
* | output |
* | --- |
* | "Monthly token limit reached" |
*
* @param {Admin_Ai_Chat_Status_Token_LimitInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_status_token_limit = /** @type {((inputs?: Admin_Ai_Chat_Status_Token_LimitInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Status_Token_LimitInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_status_token_limit(inputs)
	if (locale === "de") return de_admin_ai_chat_status_token_limit(inputs)
	if (locale === "es") return es_admin_ai_chat_status_token_limit(inputs)
	if (locale === "fr") return fr_admin_ai_chat_status_token_limit(inputs)
	if (locale === "nl") return nl_admin_ai_chat_status_token_limit(inputs)
	if (locale === "it") return it_admin_ai_chat_status_token_limit(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_status_token_limit(inputs)
	if (locale === "pl") return pl_admin_ai_chat_status_token_limit(inputs)
	if (locale === "hu") return hu_admin_ai_chat_status_token_limit(inputs)
	return ro_admin_ai_chat_status_token_limit(inputs)
});
export { admin_ai_chat_status_token_limit as "admin.ai_chat.status_token_limit" }